/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Schedule_KindInputs */

const cs_field_schedule_kind = /** @type {(inputs: Field_Schedule_KindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typ plánu`)
};

const en_field_schedule_kind = /** @type {(inputs: Field_Schedule_KindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schedule type`)
};

/**
* | output |
* | --- |
* | "Schedule type" |
*
* @param {Field_Schedule_KindInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const field_schedule_kind = /** @type {((inputs?: Field_Schedule_KindInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Schedule_KindInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_schedule_kind(inputs)
	return cs_field_schedule_kind(inputs)
});